import { TableAbstract } from "shared/components/Components";
import { useMercuryContext } from "../../context";
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import TimezoneConverter from "components/timezone-converter";
import useBreakpoint from "antd/es/grid/hooks/useBreakpoint";
import InvoiceLineItemForm from "./InvoiceLineItemForm";
import { Space } from "antd";
import PermissionWrapper from "shared/components/PermissionWrapper";
import { checkPermissions } from "common/utils/checkPermissions";
import { SwitchFilter } from "stories/filters/switch-filter/SwitchFilter";
import { descriptionColumn } from "shared/table/columnsConfig";
import { TagsRenderer } from "shared/components/RenderTags";
import { TextFilter, BooleanFilter } from "shared/components/Components";
import { ServiceFilterById } from "./Service.Filter";
import { EmpowerDepartmentFilter } from "./EmpowerDepartment.Filter";
class InvoiceLineItems extends TableAbstract<any> {
  defaultSortField = "name";

  constructor(props: any) {
    super(props);
    const col = this.state as any;
    col.pinnedRight = ["actions"];
    col.pinnedColumns = [{ id: "actions", fixed: "right" }];
    const actionsCol = this.columns.find((c: any) => c.id === "actions");
    if (actionsCol) {
      actionsCol.fixed = "right";
      actionsCol.width = actionsCol.width ?? 160;
    }
  }

  FilterComponents = [
    {
      id: "name",
      name: "name",
      title: "Name",
      component: TextFilter,
      active: true
    },
    {
      id: "serviceTypeId",
      name: "serviceTypeId",
      title: "Service",
      component: ServiceFilterById,
      active: true
    },
    {
      id: "empowerDepartment",
      name: "empowerDepartment",
      title: "Empower Department",
      component: EmpowerDepartmentFilter,
      active: true
    },
    {
      id: "active",
      name: "active",
      title: "Active",
      component: BooleanFilter
    },
    {
      id: "includeDeleted",
      name: "deleted",
      title: "Deleted",
      component: SwitchFilter,
      active: true,
    },
  ];

  columns = [
    {
      id: "name",
      title: "Name",
      dataIndex: "name",
      sorter: true,
      fixed: undefined,
      width: 160,
    },
    descriptionColumn,
    {
      id: "category",
      title: "Category",
      dataIndex: "category",
      sorter: true,
      fixed: undefined,
      width: 130,
    },
    {
      id: "varServiceType",
      title: "VAR Service Type",
      dataIndex: "varServiceType",
      sorter: true,
      fixed: undefined,
      width: 150,
    },
    {
      id: "rateType",
      title: "Rate Type",
      dataIndex: "rateType",
      fixed: undefined,
      width: 130,
    },
    {
      id: "createdAt",
      title: "Creation Timestamp",
      dataIndex: "createdAt",
      fixed: undefined,
      width: 160,
      render: (text: string) => <TimezoneConverter date={text} />,
    },
    {
      id: "serviceTypeName",
      title: "Service",
      dataIndex: "serviceTypeName",
      width: 100,
    },
    {
      id: "empowerDepartmentName",
      title: "Empower Department",
      dataIndex: "empowerDepartmentName",
      width: 160,
    },
    {
      id: "active",
      title: "Active",
      dataIndex: "active",
      width: 75,
      fixed: undefined,
      render: (text: string, record: any) =>
        record.active ? (
          <CheckOutlined style={{ color: "var(--tertiary-color)" }} />
        ) : (
          <CloseOutlined style={{ color: "var(--red)" }} />
        ),
    },
    {
      id: "deleted",
      title: "Deleted",
      dataIndex: "deleted",
      width: 75,
      fixed: undefined,
      render: (text: string, record: any) =>
        record.deleted ? (
          <CheckOutlined style={{ color: "var(--tertiary-color)" }} />
        ) : (
          <CloseOutlined style={{ color: "var(--red)" }} />
        ),
    },
    {
      id: "actions",
      title: "Actions",
      width: 160,
      fixed: "right",
      render: (_: any, record: any) => {
        const userPermissions = this.userContext.userDetails?.permissions || [];
        const canEdit =
            checkPermissions(userPermissions, [
          {
            customerApplication: "Mercury",
            permissionName: "Invoice Line Items",
            action: "edit",
          },
        ]);
        const canDelete =
            checkPermissions(userPermissions, [
          {
            customerApplication: "Mercury",
            permissionName: "Invoice Line Items",
            action: "delete",
          },
        ]);
        return record?.deleted ? (
          <PermissionWrapper
            hasPermissions={canEdit}
            children={
              <InvoiceLineItemForm
                disabled={!canEdit}
                mode="restore"
                editData={record}
                refreshList={() => this.reload()}
              />
            }
          />
        ) : (
          <Space align="center">
            <PermissionWrapper
              hasPermissions={canEdit}
             children={
                <InvoiceLineItemForm
                  mode="edit"
                  editData={record}
                  refreshList={() => this.reload()}
                  disabled={!canEdit}
                />
             }
            />
            <PermissionWrapper
              hasPermissions={canDelete}
             children={
                <InvoiceLineItemForm
                  mode="delete"
                  editData={record}
                  refreshList={() => this.reload()}
                  disabled={!canDelete}
                />
            }
            />
          </Space>
        );
      },
    },
  ];

  renderActions() {
    const userPermissions = this.userContext.userDetails?.permissions || [];
    const canCreate =
        checkPermissions(userPermissions, [
      {
        customerApplication: "Mercury",
        permissionName: "Invoice Line Items",
        action: "create",
      },
    ]);

    return (
      <Space size="small">
        <PermissionWrapper
          hasPermissions={canCreate}
          children={
            <InvoiceLineItemForm
              disabled={!canCreate}
              refreshList={() => this.reload()}
            />
          }
        />
      </Space>
    );
  }

  rowClassName = (record: any): string => {
    return "row";
  };

  async fetch() {
    const { sortOrder, sortField } = this.state;
    const filters = this.filtersToQuery();

    const res = await this.userContext.invoicingClient.post(
      `/invoicing-v1/line-item-definitions/search`,
      {
        filter: {
          deleted: filters.deleted ?? false,
          ...filters,
        },
        sort: {
          [sortField || "name"]: sortOrder === "ascend" ? 1 : -1,
        },
        pagination: {
          pageNumber: this.currentPage || 1,
          resultsPerPage: this.itemsPerPage,
        },
      }
    );
    console.log(res);
    return { data: res.data } as any;
  }

  pageTitle = "Manage Invoice Line Items - Mercury";
  title = "Invoice Line Items";
  pageClass = "invoiceLineItemsTable";
}

export default function ManageInvoiceLineItems() {
    const
    context = useMercuryContext(),
    breaks = useBreakpoint();

  return (
    //@ts-ignore
    <InvoiceLineItems
      id={"ManageInvoiceLineItems"}
      context={context as any}
      useLegacyEndpoints={false}
      breaks={breaks as any}
      hasSidebar={true}
      noSelect
    />
  );
}
